const state = {
  profile: {
    photoURL: '',
    name: ''
  }
};

export default state;

